import React, { Component } from "react";
import close_btn from '../../../images/close_btn.svg';
import Payment from '../../../images/payment_new.png';
import { userService } from "../../../_services";
//import PaymentForm from "../../../components/PaymentForm";Commented because not in use
import signupcheck from '../../../images/payment_success.svg';
import { GoogleSpreadsheet } from "google-spreadsheet";
import PaymentFormNew from "../../PaymentFormNew";
//import CardPartial from "../../Order_Cards/cardPartial";
import domtoimage from 'dom-to-image';
class OrderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserId: '',
            UserName: '',
            Fname: '',
            Lname: '',
            Phone: '',
            Email: '',
            Address1: '',
            Address2: '',
            Country: 'United States',
            State: '',
            City: '',
            Zip: '',
            fullName: '',
            carddetails: '',
            title: 'Payment Information',
            loaded: false,
            loader: false,
            Isshowpayment: false,
            show_Userdetail_popup: true,
            SuccessMessage: false,
            orderid: '',
            gn: '',
            date: '',
            group_number: '',
            base64blob: '',
            errorMsg: '',
            errors: {
                UserName: '',
                Fname: '',
                Lname: '',
                Phone: '',
                Email: '',
                Address1: '',
                Address2: '',
                State: '',
                City: '',
                Zip: '',
                orderid: '',
                gn: '',
                date: '',
                cardStyle: '',
                quantity: '',
                group_number: '',
            },
            cardStyle: 'Rounded',
            next_step: false,
            quantity: '100',
            total_price: '28.99',
            quantity_list: [{ quantity: 100, price: { sq: 24.99, rd: 28.99 } }, { quantity: 500, price: { sq: 44.99, rd: 52.99 } }, { quantity: 1000, price: { sq: 59.99, rd: 71.99 } }, { quantity: 5000, price: { sq: 191.99, rd: 276.99 } }, { quantity: 10000, price: { sq: 335.99, rd: 499.99 } }],
            cardStyle_types: ['Rounded', 'Square'],
            AddressData: {
                Country: [
                    'United States'
                ],
                State: [
                    'Please select state',
                    'Alabama',
                    'Alaska',
                    'Arizona',
                    'Arkansas',
                    'California',
                    'Colorado',
                    'Connecticut',
                    'Delaware',
                    'Florida',
                    'Georgia',
                    'Hawaii',
                    'Idaho',
                    'Illinois',
                    'Indiana',
                    'Iowa',
                    'Kansas',
                    'Kentucky',
                    'Louisiana',
                    'Maine',
                    'Maryland',
                    'Massachusetts',
                    'Michigan',
                    'Minnesota',
                    'Mississippi',
                    'Missouri',
                    'Montana',
                    'Nebraska',
                    'Nevada',
                    'New Hampshire',
                    'New Jersey',
                    'New Mexico',
                    'New York',
                    'North Carolina',
                    'North Dakota ',
                    'Ohio',
                    'Oklahoma',
                    'Oregon',
                    'Pennsylvania',
                    'Rhode Island',
                    'South Carolina',
                    'South Dakota',
                    'Tennessee',
                    'Texas',
                    'Utah',
                    'Vermont',
                    'Virginia',
                    'Washington',
                    'West Virginia',
                    'Wisconsin',
                    'Wyoming'
                ]
            },
            stuck: false

        };
        this.noerrors = {
            UserName: '',
            Fname: '',
            Lname: '',
            Phone: '',
            Email: '',
            Address1: '',
            Address2: '',
            State: '',
            City: '',
            Zip: '',
            orderid: '',
            gn: '',
            date: '',
            cardStyle: '',
            quantity: '',
            group_number: '',
        }
        this.submit_user_detail = this.submit_user_detail.bind(this);
        this.toggle_user_detail = this.toggle_user_detail.bind(this);
        this.toggle_Payment_pop = this.toggle_Payment_pop.bind(this)
    }
    componentDidMount() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.GetUserAccountInfo(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        this.setState({ show_Payment_popup: true });
        if (this.props.groupNumbers && this.props.groupNumbers.length) this.setState({ group_number: this.props.groupNumbers[0].groupnumber })
    }
    componentWillMount() {
        userService.GetPaymentStuff('')
            .then(
                apidata => {
                    if (apidata.length > 0) {
                        try {
                            const that = this;
                            let sqPaymentScript = document.createElement('script');
                            sqPaymentScript.src = apidata[0].sqPaymentScript;
                            sqPaymentScript.type = "text/javascript"
                            sqPaymentScript.async = false;
                            sqPaymentScript.onload = () => {
                                that.setState({
                                    loaded: true
                                })
                            };
                            document.getElementsByTagName("head")[0].appendChild(sqPaymentScript);
                        }
                        catch (error) { }
                    }
                });
    }
    toggle_SucccessMessage = (e) => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        let apptype = Usermeta_Data.split(':')[0];
        userService.GoogleSheetEntry(apptype)
            .then(
                apidata => {
                    if (apidata.length > 0) {
                        try {
                            this.setState({ orderid: apidata[0].orderId, gn: apidata[0].groupNumber, date: apidata[0].date });
                            this.GetGooglesheetEntry(this.state.orderid, this.state.gn, this.state.date)
                        }
                        catch (error) { }
                    }
                });
        this.setState({ SuccessMessage: e });
    }
    GetGooglesheetEntry(orderid1, gn1, date1) {
        //const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
        //const SHEET_ID = process.env.REACT_APP_SHEET_ID;
        //const CLIENT_EMAIL = process.env.REACT_APP_GOOGLE_CLIENT_EMAIL;
        //const PRIVATE_KEY = process.env.REACT_APP_GOOGLE_SERVICE_PRIVATE_KEY;Commented because not in use

        let getlogin = window.location.href;

        if (getlogin.toLowerCase().includes("release-backoffice") || getlogin.toLowerCase().includes("dev-backoffice") || getlogin.toLowerCase().includes("localhost:")) {
            const doc = new GoogleSpreadsheet("1JZS0igMTpHBLZ_la4W0rKvrrb32SNvGAgAjjf3fJ4C8");
            const appendSpreadsheet = async (row) => {
                try {
                    await doc.useServiceAccountAuth({
                        client_email: "google-spread-sheet@cohesive-idiom-332408.iam.gserviceaccount.com",
                        private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC/+TBrXzEDSGqQ\nPpXZnhB6kr+h9mz16cntIP1a9w4lWUSmNeThFRy0xAfZOrSBj4BhNkrOmYbVvr47\nwFQg+KurLAqjJg9duJoygR79UPAYjVuiHuHAllXDlr3vHwjPsPs/kBR8uq/5Typ3\n8opPVZGVNgv4D9Jg5I+4457SyJTpN/7GxcpUuWks+k/HpCLRT3zhsDhJdIavQBI3\ngFOn0VpsU1YLC0iKppm07saMv9st2mfBJ4dUHVgAP70Sd8X0b/4rhTh2hveVoDnf\nYUwOy8CgqpLhpkiNgu8nXJh9ozjOPQdwYqpycgoRgYnejD8U31D2gKxCwQ4yGwpK\na1adQPJDAgMBAAECggEACRLEhJajsOWHz9h9aaMsYTa1YvjMLpVFq3T/NIDvxLki\n4v4yGqdOS4bmXhCFvofjR/TydTBRbKHOyPEuqL5IEteKiyp92G6krxVmOw/LwUVR\nGuj9v4X7eLqTsI0VdAeH4Hm1Vi3WqmBg//lRKy2+q0A6MZfB2D2FQ3ZSp+C+FQWw\n4TVRFZVG8TYOIziMuJqkr+UwMYL2OLw6XjqCMloIzgGmZt4gDNSPAR25yJBFVswk\n/Hh4mPXQpNSnn6qQetT7YTqC1inxfg7tZ1aOHXOfs5hCN//v0XPpgx1Tlg0cJiyt\nmm9EdDNg3+fA6BlyfoSwfvng/6TATt3/w/XvogoSCQKBgQDDu6op8crLqXcPDXZ2\nEZdB2GuSSk0eNzpcg6y7OBGjP3cql7SvTkhCOa593zUTDU6bac59E5QIQBD1jGLb\n7Qb8zXwYnjBsipX+BrbMubJaaD3ImsbpcipNsK+zPZsViaE9UbcFSN6Ii3w2lVH/\nkvo12cYWyue6uQUpTrYUH3YMOQKBgQD7FSy113nqS0V8ioRLQPMs5nvkDF1bhKvn\nqpSKr/JdinY7W9Kosc0k4wl/PhZ2tsJH2RuLehDtWNlTa0nWczoLTxXjVTHq314V\nJT38QNS07IRHAvcGEECf5B0dK87t5UoHRPz6tHqU4YAyMq1JDla+qFSZZF1mg26s\nIjR8zRNqWwKBgQCNePIYWRy0MevNJHTwB+zk+dFernepFFAJmF7b/z24WeH/FiHR\n5+oQe/KkJhYNjDu51zMZcnI3uF7JrEu0HFFFnhxJCuWDPnQFZMLxnHLOJ7Qob76/\n8vWiq8eC7U9PtOenE44Ossmttev0496dtJVHIP2tccEmVB7n6W1vhAHl+QKBgDZg\nKpOi+6sq6/yBvw7RHRjfPXtw1hMI03XTcmHqotFxOBO42hFgmC3h4V+mIZVKFR8c\nPKPjJqFQOZigRphj0fE7CmF2RN45y5VGwHrNy4L3Kdp7IOY2RNibvVZg82p/2p1i\namsdBOMTRwEYCoEk0tJtgAzMOJIH6sLqkXVpsEe7AoGBAJb/UDJdwSLY0ERyUiry\niNl1fVr3oswGMRyuSfpAHjpAd1rLDs3gOFP28vDCUL1I766jbApaJGygkCjvxmxQ\nGWIdndYxFcrAak0eqy2ZP8qFH0qZA7JKqNSIhw8fCCZ8F54LceKVAHdSOxL+i4b+\nLcc5g+vfgvViBdJWSAd1DHFf\n-----END PRIVATE KEY-----\n"
                    });
                    // loads document properties and worksheets
                    await doc.loadInfo();
                    const sheet = doc.sheetsById["0"]; //Commented because not in use
                    //const result = await sheet.addRow(row); //Commented because not in use
                    await sheet.addRow(row)
                } catch (e) {
                    console.error('Error: ', e);
                }
            };
            const newRow = { OrderID: orderid1, Date: this.state.date, FirstName: this.state.Fname, LastName: this.state.Lname, Group_Number: gn1, Email: this.state.Email, Address1: this.state.Address1, Address2: this.state.Address2, City: this.state.City, State: this.state.State, Zip: this.state.Zip, CardsQuantity: this.state.quantity, CardType: this.state.cardStyle, Phone: '-', ProductName: '-', ProductId: '-', Price: '-', Quantity: '-', Pharmacy:  '-', Size: '-' };
            appendSpreadsheet(newRow);
        }
        else {
            const doc = new GoogleSpreadsheet("1WdcHyaZGax6Bpo6sY7r6vbRaiOuZBsC-aJkAWntYIHo");
            const appendSpreadsheet = async (row) => {
                try {
                    await doc.useServiceAccountAuth({
                        client_email: "paymententry@crafty-key-333107.iam.gserviceaccount.com",
                        private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCZXP7jo93HHaaU\n3vqbnHxAnbjRcBoTnNJhsnJRIkEQGjOZAwfQJdTjIjsEHuPf0W0m02DRSj47S2l7\ngTWtkirkTdCQO48z8t4r8wG4yG5/GplAZz1vLc4Mfmv4WRSYdDoCVAtFeqSQGWwH\nsvjplxiGppGnLILl08FsEG3PBrU8uv0E6Sgrv8Al453XaJrI2T38uvxG15yIyZYl\nyGYMpD4HLxpWcZqRH3GIqDg5gBndkd34zcwDW6TYQEvf+XWnSeE8Rvf1JlXOFho+\nmOdU1IE+ETvmEwll6F01okKoRuvC67IfkmuGiieENXRve7NLncqPYUwX2TiE7H2X\n9CctJVYFAgMBAAECggEAG8xOayadoWTPd/Z+yEvx/ahZAqVmJJ3tSEYXEHu7/VYy\neg6hkOn6j3z544JR3ZTRSxNPXkAtzYOayAcgmqh+28j6/9m72Deya5btfffeh21j\nz9emvAs6aOtVWLuUzxlqFlfzfxF+2JuzCCY5leWMTYPNrNaVl2Dtk0/bB4Z4vVwD\nX4X9NFShUEIQzghlrFGdht1nztluOX+1ZGnhfhf5FfbZtSlOR3UlUuSjvaEWMAhg\nghHru/s8PMdsDusTMRv3tgjbLac70nTYsmOdw7eIaEM16WeU0McHSNsaA7h8Nm7u\nsyS38HpgvDlRF6uWDq8qD1x8HSGhORVTLEQWEDEYNQKBgQDSpwjysfYjW77Kx17v\nB0ZYViroV1RHEPXLxhbPT4z+x7eor8KW7JtHSnKUY5bnuswbYq6Sq/vjizH8V8Hq\nFvdI+YyXzU+mBB0Hjat/4PDp8IDFQ/Gte7fVHIFYlqmHO9pUfZqPjqqnTVBOj0a3\nYLGcoFD+NTcCZkrbokFrvesmFwKBgQC6YMcAIYqQHslcudo5BtTS5CfuQnTOoJS8\nV3oemCofHgV4Ps8uCa/16s8yNwAQpMD21kpfYVpGyQtGicQICUhtPtu1uOMW7924\n0eShM4LIa9nnexHnCbi1cXTQUdMvPBGJCLZuAz60+p3qkZjgiuNe6Dhr2VRMWDPv\nNL/vhDFSQwKBgQCpr9QNbD2SDf2K6z8V3Q5ValP2BSLmfEsDcvY82SACvG69e5eM\na9xJeTcDQZX15Qs1pDBsBg5KJX6Gf0q9fvKD3kHappBac0XPJ9fWkyR9zjZssWal\nENvs16F58yNsxFIDbYpryci+LBFctx2H6mQofxu/Kq69SBlVA0cfu0UI0QKBgHjD\nto5GLYN+/1i+8ECdRY+02I7QruEoOdfkErP6QujQyhiFEjexfTuqP0E5VCh0qLgI\nWD5/VUCiilTVdZkDctOetDyGpVa6a/+SuUMennKBN7t/CjWbHf0rm9ZT/rQPhwk1\nBQg5wAsCjQpt9xIfzH41mEGBm9awHE617lwjWtYDAoGBAKSQ8+sa/YelAXcqc2J/\nUQ5Bqf7z0mxUCMIrtAc1Vt7V+xXlCHAG050adXZJ56tSqHVOINn4xn7ZU0yjxkEg\nRUYLahOK4jjBIrSZLZe0Osyu/HoD6o3VxlE/PJVX9Ag2xSgJL28JLBSN/5JOh+0v\nF1Hjm/gg+H17pFSNHRNQVv+6\n-----END PRIVATE KEY-----\n"
                    });
                    // loads document properties and worksheets
                    await doc.loadInfo();

                    const sheet = doc.sheetsById["0"]; //Commented because not in use
                    //const result = await sheet.addRow(row);Commented because not in use
                    await sheet.addRow(row)
                } catch (e) {
                    console.error('Error: ', e);
                }
            };
            const newRow = { OrderID: orderid1, Date: this.state.date, FirstName: this.state.Fname, LastName: this.state.Lname, Group_Number: gn1, Email: this.state.Email, Address1: this.state.Address1, Address2: this.state.Address2, City: this.state.City, State: this.state.State, Zip: this.state.Zip, CardsQuantity: this.state.quantity, CardType: this.state.cardStyle };
            appendSpreadsheet(newRow);
        }

    }
    toggle_user_detail = (e) => {
        e.stopPropagation();
        this.setState({ show_Userdetail_popup: false, SuccessMessage: false, Isshowpayment: false, show_Payment_popup: false });
    }
    toggle_Payment_pop = (e) => {
        e.stopPropagation();
        this.setState({ Isshowpayment: !this.state.Isshowpayment, show_Payment_popup: true, show_Userdetail_popup: true });
    }
    GetUserAccountInfo(UserId, UserName) {
        try {
            userService.GetUserAccountInfo(UserId, UserName)
                .then(
                    apidata => {
                        try {
                            if (apidata.length > 0) {
                                if (apidata[0].code !== "-1") {
                                    this.setState({ UserId: UserId, UserName: apidata[0].username, Fname: apidata[0].fname, Lname: apidata[0].lname, Phone: apidata[0].phone, Email: apidata[0].email, Address1: apidata[0].address1, Address2: apidata[0].address2, State: apidata[0].stateName, City: apidata[0].cityName, Zip: apidata[0].zipCode });
                                }
                                else {

                                }
                            }
                            else {

                            }
                        }
                        catch (error) {
                        }
                    }
                );
        }
        catch (error) {
        }
    }
    submit_user_detail = (e) => {
        e.stopPropagation();
        try {
            let errors = this.state.errors;
            const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\(\d{1,4}\)|\d{1,4})[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
            if (this.state.Fname.length < 3)
                errors.Fname = 'Minimum 3 characters long';
            if (this.state.Fname.length > 20)
                errors.Fname = 'Maximum 20 characters long';
            //errors.Fname = 'First Name must be at least 3 characters long';
            if (this.state.Lname.length < 2)
                errors.Lname = 'Minimum 2 characters long';
            if (this.state.Lname.length > 20)
                errors.Lname = 'Maximum 20 characters long';
            if (!userService.ValidPhone(this.state.Phone) || this.state.Phone === "")
                errors.Phone = 'Phone number is not valid';
            //errors.Lname = 'Last Name must be at least 2 characters long';
            if (this.state.Address1.length < 1)
                errors.Address1 = 'Please Input street address';
            if (this.state.Address1.length > 25)
                errors.Address1 = 'Please Input valid street address';
            if (this.state.Address2.length > 25)
                errors.Address2 = 'Please Input valid street address';
            if (this.state.State === 'Please select state' || this.state.State === '')
                errors.State = 'Please Select State';
            if (this.state.City.length < 2)
                errors.City = 'Please input city';
            if (this.state.City.length > 35)
                errors.City = 'Please input valid city';
            if (this.state.Zip.length < 5 || this.state.Zip.length > 5)
                errors.Zip = 'Please input valid zipcode';
            if (JSON.stringify(errors) !== JSON.stringify(this.noerrors)) {
                this.setState({ errors: errors });
            }
            else {
                let states_data = this.state;
                this.SetUserAccountInfo(states_data.UserId, states_data.UserName, states_data.Fname, states_data.Lname, states_data.Phone, states_data.Email, states_data.Address1, states_data.Address2, states_data.Country, states_data.State, states_data.City, states_data.Zip);

            }
        }
        catch (error) {
        }
    }
    SetUserAccountInfo(UserId, UserName, Fname, Lname, Phone, Email, Address1, Address2, CountryName, StateName, CityName, ZipCode) {
        this.setState({loader: true})
        try {
            userService.SetUserAccountInfo(UserId, UserName, Fname, Lname, Phone, Email, Address1, Address2, CountryName, StateName, CityName, ZipCode)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code !== '-1') {
                                this.setState({ SuccessMessage: false, show_Userdetail_popup: false, Isshowpayment: true, loader: false });
                            } else {
                                this.setState({ SuccessMessage: false, loader: false, errorMsg: apidata[0].message });
                            }
                        }
                    }
                );
        }
        catch (error) {
            this.setState({ loader: false })
        }
    }
    removeError = (event) => {
        let errors = this.state.errors;
        errors[event.target.previousElementSibling.previousElementSibling.name] = '';
        this.setState({ errors: errors });
    }
    HandleInput = (event) => {
        let errors = this.state.errors;
        if (event.target.name === "Fname" || event.target.name === "Lname") {
            if (event.target.value !== "") {
                let special = /^[a-zA-Z]+$/g;
                if (event.target.value.match(special)) {
                    this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                    errors[event.target.name] = '';
                    this.setState({ errors: errors });
                }
                else {
                    return false;
                }
            }
        }
        if (event.target.name === "Phone") {
            if (event.target.value !== "") {
                let phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\(\d{1,4}\)|\d{1,4})[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

                if (phoneRegex.test(event.target.value)) {
                    this.setState({ [event.target.name]: event.target.value });
                    errors[event.target.name] = '';
                } else {
                    errors[event.target.name] = "Invalid phone number format";
                }
                this.setState({ errors: errors });
            }
        }
        if (event.target.name === "City") {
            if (event.target.value !== "") {
                let special = /^[a-zA-Z ]*$/;///^[a-zA-Z]+$/g;
                if (event.target.value.match(special) || event.target.value === '') {
                    this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                    errors[event.target.name] = '';
                    this.setState({ errors: errors });
                }
                else {
                    return false;
                }
            }
        }
        if (event.target.name === "Zip") {
            let str = event.target.value;
            str = str.replace(/[^0-9]/g, '');
            this.setState({ Zip: str });
            if (event.target.value !== "") {
                let special = /^[0-9\b]+$/;
                if (event.target.value.match(special) || event.target.value === "") {
                    this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                    errors[event.target.name] = '';
                    this.setState({ errors: errors });
                }
                else {
                    return false;
                }
            }
        }
        else {
            this.setState({ [event.target.name]: event.target.value });
            errors[event.target.name] = '';
            this.setState({ errors: errors });
        }
    }
    handleChange = (event => {
        this.setState({ [event.target.name]: event.target.value });
    })
    nextScreen = (id) => {
        this.setState({ next_step: true });
        /*domtoimage.toPng(document.getElementById(id))
            .then((blob) => { // Arrow function ensures `this` refers to the component instance
                this.setState({ next_step: true, base64blob: blob });
            })
            .catch((error) => {
                console.error('Error generating image:', error);
            });*/
    }
    dofocus = (event) => {
        event.target.previousElementSibling.focus();
    }
    render() {
        const { errors } = this.state;
        return (
            <div>
                {/*<CardPartial forOrder={true} dateTime={(Math.floor(Math.random() * 1313131313131)).toString()} groupnumber={this.state.group_number} cardStyle={this.state.cardStyle} />*/}
               {/*<div className="ordered-cards" id={this.state.group_number + 0}>
                    {this.state.cardStyle === 'Square' ? <div className="squared">
                        <div className="card-front">
                            <img src={cardFrontSquare} />
                            <div className="groupNumber">{this.state.group_number}</div>
                        </div>
                        <div className="card-back">
                            <img src={cardBackSquare} />
                        </div>
                    </div> : <div className="rounded">
                        <div className="card-front">
                            <img src={cardFrontCircle} />
                            <div className="groupNumber">{this.state.group_number}</div>
                        </div>
                        <div className="card-back">
                            <img src={cardBackCircle} />
                        </div>
                    </div>}
                </div>*/}
                {this.state.show_Payment_popup === true ?
                    <div className="contentarea signup-popup order-section">
                        <div className="content_sec">
                            <div className={`${this.props.forCard ? "add_url_pop payment_popup ordercard_payment_modal" : "add_url_pop payment_popup"}`}>
                                <div className="Mask">
                                    <div className="header">
                                        <h3>NuLifeSpan Rx Marketplace</h3>
                                        <div className="close" onClick={this.props.toggle_user_detail.bind(this)}>
                                            <img src={close_btn} alt="" />
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="scroll-section">
                                            {!this.props.forCard ? <div className="Rectangle">
                                                <div className="Get-a-jump-start-wit"><span>Get a jump start with</span> NuLifeSpan Rx Marketplace</div>
                                                <img src={Payment} className="Group-16" alt="" />
                                                <div className="-Featuring-500-of-o">
                                                    <ul>
                                                        <li>Featuring 1000 of our standard cards</li>
                                                        <li>6 clear PVC displays</li>
                                                        <li>6 Box displays</li>
                                                        <li>Conveniently bundled up & assigned for you!</li>
                                                    </ul>
                                                </div>
                                            </div> : null}
                                            {this.state.SuccessMessage ?
                                                <div className="right-view success-msg">
                                                    <img src={signupcheck} alt="" />
                                                    <h3>Thank you for your payment.</h3>
                                                    You will receive an email with your<br />
                                                    receipt and shipping details

                                                </div> :

                                                <div className="right-view">
                                                    {
                                                        this.state.show_Userdetail_popup === true ?
                                                            <>
                                                                {this.props.forCard && !this.state.next_step ? < div >
                                                                    <div className="personal_box UserInfo">
                                                                        <div className="Shipto">
                                                                            Select Card Details
                                                                        </div>
                                                                        <div className={errors.cardStyle.length > 0 ? 'drpdown errors full same' : 'drpdown full same'}>
                                                                            <select defaultValue={this.state.cardStyle} value={this.state.cardStyle}
                                                                                onChange={(e) => {
                                                                                    const selectedCardStyle = e.target.value;
                                                                                    const cardSt = selectedCardStyle.toLowerCase();
                                                                                    const selectedItem = this.state.quantity_list.find(item => item.quantity === parseInt(this.state.quantity));
                                                                                    const price = selectedItem ? (cardSt === 'rounded' ? selectedItem.price['rd'] : selectedItem.price['sq']) : 0;
                                                                                    this.setState({
                                                                                        cardStyle: selectedCardStyle,
                                                                                        total_price: price
                                                                                    });
                                                                                }} name="cardStyle">
                                                                                {this.state.cardStyle_types.map(item => <option key={item} value={item} >{item}</option>)}
                                                                            </select>
                                                                            <span>Card Style*</span>
                                                                            {errors.cardStyle.length > 0 &&
                                                                                <span onClick={this.removeError.bind(this)}>{errors.cardStyle} </span>}
                                                                        </div>
                                                                        <div className={errors.quantity.length > 0 ? 'drpdown errors full same' : 'drpdown full same'}>
                                                                            <select defaultValue={this.state.quantity} value={this.state.quantity}
                                                                                onChange={(e) => {
                                                                                    const selectedQuantity = e.target.value;
                                                                                    const cardSt = this.state.cardStyle.toLowerCase();
                                                                                    const selectedItem = this.state.quantity_list.find(item => item.quantity === parseInt(selectedQuantity));
                                                                                    const price = selectedItem ? cardSt === 'rounded' ? selectedItem.price['rd'] : selectedItem.price['sq'] : 0;
                                                                                    this.setState({
                                                                                        quantity: selectedQuantity,
                                                                                        total_price: price
                                                                                    });
                                                                                }} name="quantity">
                                                                                {this.state.quantity_list.map(item => <option key={item.quantity} value={item.quantity} >{item.quantity}</option>)}
                                                                            </select>
                                                                            <span>Select Quantity*</span>
                                                                            {errors.quantity.length > 0 &&
                                                                                <span onClick={this.removeError.bind(this)}>{errors.quantity} </span>}
                                                                        </div>
                                                                        <div className={errors.group_number.length > 0 ? 'drpdown errors full same' : 'drpdown full same'}>
                                                                            <select defaultValue={this.state.group_number} value={this.state.group_number}
                                                                                onChange={this.handleChange} name="group_number">
                                                                                {this.props.groupNumbers ?
                                                                                    this.props.groupNumbers.map(item =>
                                                                                        <option key={item.groupnumber} value={item.groupnumber} >{item.groupnumber}</option>
                                                                                    ) : null}
                                                                            </select>
                                                                            <span>Select Group No.*</span>
                                                                            {errors.group_number.length > 0 &&
                                                                                <span onClick={this.removeError.bind(this)}>{errors.group_number} </span>}
                                                                        </div>
                                                                    </div>
                                                                    {this.props.forCard ? < div className="pricing">Total Price: <strong>${this.state.total_price}</strong></div> : null}
                                                                    <div className="footer">
                                                                        <div className="yes_btn" onClick={this.nextScreen.bind(this, this.state.group_number + 0)}>Next</div>
                                                                    </div>
                                                                </div> : null}
                                                                {!this.props.forCard || (this.props.forCard && this.state.next_step) ? <div>
                                                                    <div className="personal_box UserInfo">
                                                                        <div className="Shipto">
                                                                            Ship To
                                                                        </div>
                                                                        <div className={errors.Fname.length > 0 ? 'errors same first-name' : 'same first-name'}>
                                                                            <input type="text" placeholder=" " name="Fname" value={this.state.Fname} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>First Name</span>
                                                                            {errors.Fname.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Fname} </span>}
                                                                        </div>
                                                                        <div className={errors.Lname.length > 0 ? 'errors same last-name' : 'same last-name'}>
                                                                            <input type="text" placeholder=" " name="Lname" value={this.state.Lname} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>Last Name</span>
                                                                            {errors.Lname.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Lname}</span>}
                                                                        </div>
                                                                        <div className={errors.Phone.length > 0 ? 'errors same first-name' : 'same first-name'}>
                                                                            <input type="text" placeholder=" " name="Phone" value={this.state.Phone} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>Phone Number</span>
                                                                            {errors.Phone.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Phone}</span>}
                                                                        </div>
                                                                        <div className={errors.Address1.length > 0 ? 'errors same last-name' : 'same last-name'}>
                                                                            <input type="text" placeholder=" " name="Address1" value={this.state.Address1} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>Address Line 1</span>
                                                                            {errors.Address1.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Address1}</span>}
                                                                        </div>
                                                                        <div className={errors.Address2.length > 0 ? 'errors same full' : 'same full'}>
                                                                            <input type="text" placeholder=" " name="Address2" value={this.state.Address2} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>Address Line 2</span>
                                                                            {errors.Address2.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Address2} </span>}
                                                                        </div>
                                                                        <div className={errors.State.length > 0 ? 'drpdown errors full same' : 'drpdown full same'}>
                                                                            <select defaultValue={this.state.State} value={this.state.State}
                                                                                onChange={this.handleChange} name="State">
                                                                                {this.state.AddressData.State.map(item => <option key={item} value={item} >{item}</option>)}
                                                                            </select>
                                                                            <span>State*</span>
                                                                            {errors.State.length > 0 &&
                                                                                <span onClick={this.removeError.bind(this)}>{errors.State} </span>}
                                                                        </div>
                                                                        <div className={errors.City.length > 0 ? 'errors same first-name' : 'same first-name'}>
                                                                            <input type="text" placeholder=" " name="City" value={this.state.City} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>City*</span>
                                                                            {errors.City.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.City} </span>}
                                                                        </div>
                                                                        <div className={errors.Zip.length > 0 ? 'errors same last-name' : 'same last-name'}>
                                                                            <input type="text" placeholder=" " name="Zip" value={this.state.Zip} onChange={this.HandleInput} onFocus={this.HandleInput} />
                                                                            <span onClick={this.dofocus.bind(this)}>Zip/Postal Code*</span>
                                                                            {errors.Zip.length > 0 &&
                                                                                <span className="error" onClick={this.removeError.bind(this)}>{errors.Zip} </span>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="footer">
                                                                        <div className={`yes_btn ${this.state.loader ? 'loader disabled' : ''}`} onClick={this.submit_user_detail.bind(this)}>Save & Continue</div>
                                                                        {this.state.errorMsg && <div className="error" style={{ position: 'absolute', left: '220px', marginBottom: '0', bottom: '30px', width: '50%', justifyContent: 'flex-start' }}>{this.state.errorMsg}</div>}
                                                                    </div>
                                                                </div> : null}
                                                            </> : null
                                                    }
                                                    <div>
                                                        {this.state.Isshowpayment === true ?
                                                            <div>
                                                                <div className="shipping">
                                                                    <h3>Shipping Address</h3>
                                                                    <address>
                                                                        {this.state.Fname}  {this.state.Lname}
                                                                        <br></br> {this.state.Address1} {this.state.Address2} {this.state.State} {this.state.City}
                                                                        <br></br>USA, {this.state.Zip}
                                                                    </address>
                                                                    <div className="close" onClick={this.toggle_Payment_pop.bind(this)}>change</div>
                                                                </div>
                                                                <h2> Payment Information</h2>
                                                                {/*<PaymentForm paymentForm={window.SqPaymentForm} Fname={this.state.Fname} Lname={this.state.Lname} Address1={this.state.Address1} Address2={this.state.Address2} State={this.state.State} City={this.state.City} Zip={this.state.Zip} Email={this.state.Email} toggle_Payment_pop={this.toggle_Payment_pop.bind(this)} SuccessMessage={this.toggle_SucccessMessage} />*/}
                                                                <PaymentFormNew paymentForm={window.Square.payments} Fname={this.state.Fname} Lname={this.state.Lname} Address1={this.state.Address1} Address2={this.state.Address2} State={this.state.State} City={this.state.City} Zip={this.state.Zip} Email={this.state.Email} toggle_Payment_pop={this.toggle_Payment_pop.bind(this)} SuccessMessage={this.toggle_SucccessMessage} ProductName={this.state.cardStyle} quantity={this.state.quantity} group_number={this.state.group_number} base64blob={this.state.Phone} forCard={this.props.forCard ? this.props.forCard : ''} total_price={this.state.total_price} />

                                                            </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

            </div>
        )
    }
}
export default OrderPage;